<div class="tooth-picker-dialog-container" data-cy="tooth-picker-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title" data-cy="tooth-picker-title-label">
        Make selection
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center; position: relative;">
      <div style="width: 100%; text-align: right; height: 20px;">
        <mat-checkbox style="position: relative; z-index: 1200; right: 6px;" (change)="onSurfacePickChange($event)" data-cy="tooth-picker-surface-pick-checkbox">Surface Pick</mat-checkbox>
      </div>
      <mat-tab-group data-cy="tooth-picker-tab-group">
        <mat-tab style="position: relative;" label="Permanent" data-cy="tooth-picker-permanent-tab">
          <div class="mouth-container" data-cy="tooth-picker-mouth-container">
            <app-tooth-ui-manager [isEnableSurfacePick]="isEnableSurfacePick" (toothSelectionChanged)="onToothSelectionChange($event)" [selectedTeeth]="selectedTeeth" [isSingleToothMode]="isSingleToothMode" data-cy="tooth-picker-ui-manager"></app-tooth-ui-manager>
          </div>
        </mat-tab>
        <mat-tab disabled="true" label="Baby" data-cy="tooth-picker-baby-tab"></mat-tab>
      </mat-tab-group>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 40px;">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="cancel()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="tooth-picker-cancel-button">Cancel</button>
      <button [disabled]="!selectedTeeth || selectedTeeth.length === 0" (click)="save()" class="tdo-button tdo-save" style="margin-right: 10px;" data-cy="tooth-picker-save-button">Ok</button>
    </div>
  </div>
</div>
